import React from "react";
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import IntroSection from "../components/introsection";
import ParallelSection from "../components/parallelSlide";
import AboutSection from "../components/aboutsection";
import Productservices from "../components/productservices"

import videos from "../assets/files/video-2.mp4"
import imageviewvideo from "../assets/files/landing-image-2.png"
import Innovation from "../assets/content/main/Innovation-Center-.png"




import client01 from "../assets/content/clients/ada.png"
import client02 from "../assets/content/clients/Csir-csio.png"
import client03 from "../assets/content/clients/Defence.png"
import client04 from "../assets/content/clients/IAF.png"
import client05 from "../assets/content/clients/IAF-uniform.png"
import client06 from "../assets/content/clients/isro.png"
import client07 from "../assets/content/clients/nal.png"

import testimonials01 from "../assets/content/testimonials/1.jpg"
import testimonials02 from "../assets/content/testimonials/2.jpg"
import testimonials03 from "../assets/content/testimonials/3.png"
import testimonials04 from "../assets/content/testimonials/4.png"

gsap.registerPlugin(ScrollTrigger);


const KV_DELAY = 5;
export default function Home() {
  

  const animationRef = useRef(null);


  const detectCurrentVideo = ({ video, func, cb }) => {
    const onProgress = func || (() => {});
    const onComplete = cb || (() => {});

    const update = () => {
      if (!video) return;

      onProgress(video.currentTime);

      const progressBar = document.querySelector(
        ".kv-nav .progress-ctn .progress-bar"
      );

      if (progressBar && video.duration) {
        progressBar.style.width =
          (video.currentTime * 100) / video.duration + "%";
      }

      if (video.ended) {
        video.currentTime = 0;

        if (progressBar) {
          progressBar.style.width = "0%";
        }

        onComplete();
        return;
      }

      animationRef.current = requestAnimationFrame(update);
    };

    animationRef.current = requestAnimationFrame(update);
  };

  const stopDetectCurrentVideo = () => {
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
    }
  };

  const detectVideoEnd = () => {
    const kvTitles = document.querySelectorAll(".section--kv .title");
    const kvVideos = document.querySelectorAll(".section--kv video");

    const activeVideo = document.querySelector(
      ".swiper-slide-active video"
    );

    const progressBar = document.querySelector(
      ".kv-nav .progress-ctn .progress-bar"
    );

    gsap.killTweensOf(progressBar);

    // Stop all videos
    if (kvVideos.length > 0) {
      stopDetectCurrentVideo();

      kvVideos.forEach((video) => {
        if (!video.paused) {
          video.pause();
          video.currentTime = 0;
        }
      });

      if (progressBar) {
        progressBar.style.width = "0%";
      }
    }

    // If active slide contains video
    if (activeVideo) {
activeVideo.muted = true;

activeVideo.play()
  .then(() => {

    detectCurrentVideo({
      video: activeVideo,
      cb: () => {
        stopDetectCurrentVideo();

        if (window.swiperKV) {
          window.swiperKV.slideNext();
        }
      }
    });

  })
  .catch((err) => {
    console.log(err);
  });
      // Single slide
      if (kvTitles.length === 1) {
        activeVideo.setAttribute("loop", "");
        detectCurrentVideo({
          video: activeVideo,
        });
        return;
      }

      stopDetectCurrentVideo();

      detectCurrentVideo({
        video: activeVideo,
        cb: () => {
          stopDetectCurrentVideo();

          if (window.swiperKV) {
            window.swiperKV.slideNext();
          }
        },
      });
    } else {
      // No video slide
      if (kvTitles.length === 1) {
        gsap.set(progressBar, {
          width: "100%",
        });
        return;
      }

      gsap.to(progressBar, {
        width: "100%",
        ease: "linear",
        duration: KV_DELAY,
        onComplete: () => {
          if (window.swiperKV) {
            window.swiperKV.slideNext();
          }
        },
      });
    }
  };

  useEffect(() => {
    detectVideoEnd();

    return () => {
      stopDetectCurrentVideo();
    };
  }, []);


//   Scroll to section
 const scrollBtnRef = useRef(null);

  // example smooth scroll object
  const smoothScroll = {
    stop: () => console.log("stop"),
    start: () => console.log("start"),
    scrollTo: (y, options) => {
      window.scrollTo({
        top: y,
        behavior: "smooth",
      });

      setTimeout(() => {
        options?.callback?.();
      }, options.duration);
    },
  };

  useEffect(() => {
    const scrollBtn = scrollBtnRef.current;

    if (!scrollBtn) return;

    const handleClick = () => {
      const to = scrollBtn.getAttribute("scroll-to");

      smoothScroll.stop();

      const toH = window.innerHeight * 0.95;

      smoothScroll.scrollTo(toH, {
        duration: 100,
        callback: () => {
          gsap.delayedCall(0.3, () => {
            smoothScroll.start();
          });
        },
      });
    };

    scrollBtn.addEventListener("click", handleClick);

    return () => {
      scrollBtn.removeEventListener("click", handleClick);
    };



 
  }, []);


  const showroomRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {

      // Background parallax animation
      gsap.timeline({
        scrollTrigger: {
          trigger: ".section--showroom",
          start: "top bottom",
          end: "bottom top",
          scrub: 0.0001,
          invalidateOnRefresh: true,
          // markers: true,
        },
      }).fromTo(
        ".section--showroom .bg-container",
        {
          y: "-65%",
        },
        {
          y: "-35%",
        }
      );

      // Initial content state
      gsap.set(".section--showroom .content", {
        autoAlpha: 0,
        y: 50,
      });

      // Reveal animation
      ScrollTrigger.create({
        trigger: ".section--products",
        start: "bottom 85%",
        // markers: true,
        onEnter: () => {
          gsap.to(".section--showroom .content", {
            autoAlpha: 1,
            y: 0,
            duration: 1,
            ease: "power3.out",
          });
        },
      });

    }, showroomRef);

    return () => ctx.revert();
  }, []);

  return (
    <div>
      <main className="main">
			<div className="index">
				<section className="section section--kv no-slide" id="kv" data-color="#00040E">
					<div className="content-wrap">
						{/* //////////////////////
						//  Landing KV Video
						///////////////// */}
						<div className="swiper-container swiper-fade swiper-initialized swiper-horizontal swiper-pointer-events swiper-watch-progress swiper-backface-hidden">
							<div className="swiper-wrapper">
								
									
										<div className="swiper-slide swiper-slide-visible swiper-slide-active">
											<a className="kv-link" href="/about" data-nav="Solutions">
											<div className="swiper-zoom-container">
												<video src={videos} 
												data-status="0" 
												poster={imageviewvideo} 
												className="swiper-zoom-target"   
												muted
												playsInline
												autoPlay
												preload="auto"></video>	
											</div>

											<div className="cont-bot">
												<div className="container">
													<div className="row">
														<div className="col-14">
															<h1 className="kv-headline title" type="eng">
															<div className="box active">
																<div className="box__translate">
																	<span className="box__rotate">Precision Engineering for Aerospace, Defence & Space</span>
																</div>
															</div>
															</h1>
														</div>
													</div>
												</div>
											</div>
											</a>
										</div>
									
								
							</div>
						</div>

						<div className="cont-bot pb-c1 kv-nav">
							<div className="container">
								<div className="row progress">
									<div className="col-14">
										<div className="progress-ctn"><div className="progress-bar"></div></div>
									</div>
								</div>
								<div className="row tabs">
									<div className="col-7">
										<ul className="tab-list swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal swiper-pagination-lock" size="s" color="white" lang="en" type="button"><li className="swiper-pagination-bullet tab-item swiper-pagination-bullet-active">
          <a href="#" className="tab-btn">
          01
          </a>
          </li></ul>
									</div>
									<div className="col-7 scroll-btn" ref={scrollBtnRef} scroll-to="introduction">
										<span type="button" className="bttn bttn-scroll" color="white" dir="bottom"><span className="icon"></span></span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
	<section className="section section--introduction" id="introduction" data-color="#00040E">
					<div className="container">
						<div className="row">
							<div className="col-12 intro__text">
								<div className="content"  data-inmotion="active" motion-state="on">
									<h2 className="headline-3-kr title trn" data-trn-key="index-01">High-reliability telemetry, control, and timing systems engineered for environments where performance is non-negotiable. </h2>
								</div>
							</div>
						</div>
					</div>
				</section> 
				<IntroSection/>
			    <ParallelSection/>

				

				<div id="showroom" className="container pt-b3"  ref={showroomRef} data-color="#fff">
					<section className="section section--showroom" data-color="#fff">
						<div className="bg-container">
							<img src={Innovation} alt="Innovation"/>
						</div>

						<div className="row">
							<div className="col-6 col-offset-1">
								<div className="contents">
							
									<div className="txt-wrap" data-inmotion="active" motion-state="on">
										<h2 className="headline-3-en tit">PCC’s R&D excellence</h2>
										<p className="body2 desc trn" data-trn-key="index-08">Step into the heart of <span className="cp-name">PCC’s R&D excellence</span> 
										to explore our standard and customized COTS solutions for Defence and Aerospace.</p>
										<a href="/showroom" className="bttn bttn-txt--circle" size="m" color="white"><span className="txt" data-txt="GO EXPERIENCE">EXPLORE TECHNOLOGY</span><span className="icon"></span></a>
										<div className="space-btn headline-3-en"></div>
									</div>
								</div>
							</div>
						</div>
					</section>
				</div>
					<section className="section" data-color="#fff">
					<Productservices/>
					</section>
				

				<AboutSection/>
				
				<section className="section section--news-area" id="news" data-color="#fff">
					<div className="container">
						<div className="row">
							<div className="col-14 section--news-area__header"  data-inmotion="active" motion-state="on">
								<h2 className="headline-2-en title">Testimonials</h2>
								<p className="desc body1 trn" data-trn-key="index-09">Collaborating with world-class organizations to deliver mission-critical excellence in Defence and Aerospace.</p>
							</div>

							<div className="col-14">
								<ul className="news-list">
										
											<li className="news-item">
												<a href="/">
													<div className="news-item__header">
														{/* <div className="news-item__tag btn3-en">India</div> */}
														<div className="news-item__title body1"><span className="span"> BDL Appreciates PCC’s Technical Support for Critical Missile Flight Tests</span></div>
														<div className="news-item__date btn4-en">2022. 09. 23</div>
													</div>
													<div className="img-wrapper">
														<div className="inner">
															<img src={testimonials01} alt={testimonials01}/>
														</div>
													</div>
												</a>
											</li>
										
											<li className="news-item">
												<a href="/">
													<div className="news-item__header">
														{/* <div className="news-item__tag btn3-en">India</div> */}
														<div className="news-item__title body1"><span className="span">Project SFDR Extension: PCC Recognized for Excellence in Integrated Telemetry Systems.</span></div>
														<div className="news-item__date btn4-en">2025. 11. 15</div>
													</div>
													<div className="img-wrapper">
														<div className="inner">
															<img src={testimonials02} alt={testimonials02}/>
														</div>
													</div>
												</a>
											</li>
										
											<li className="news-item">
												<a href="/">
													<div className="news-item__header">
														{/* <div className="news-item__tag btn3-en">India</div> */}
														<div className="news-item__title body1"><span className="span">Driving Atmanirbhar Bharat: PCC Celebrates a Decade as a Recognized R&D Unit.</span></div>
														<div className="news-item__date btn4-en">2025. 05. 20</div>
													</div>
													<div className="img-wrapper">
														<div className="inner">
															<img src={testimonials03} alt={testimonials03}/>
														</div>
													</div>
												</a>
											</li>
										
											<li className="news-item">
												<a href="/">
													<div className="news-item__header">
														{/* <div className="news-item__tag btn3-en">India</div> */}
														<div className="news-item__title body1"><span className="span">Project NGARM: DRDO Places on Record Appreciation for PCC’s Technical Dedication.</span></div>
														<div className="news-item__date btn4-en">2024. 12. 10</div>
													</div>
													<div className="img-wrapper">
														<div className="inner">
															<img src={testimonials04} alt={testimonials04}/>
														</div>
													</div>
												</a>
											</li>
										
									

								</ul>
							</div>
						</div>
					</div>
				</section>

				<section className="section section--partners">
					<div className="container">
						<div className="row">
							<div className="col-6 section--partners__header"  data-inmotion="active" motion-state="on">
								<h2 className="headline-2-en tit">Trusted by Industry Leaders</h2>
								<p className="desc body1 trn" data-trn-key="index-09">Collaborating with world-class organizations to deliver mission-critical excellence in Defence and Aerospace.</p>
							</div>
						</div>
					</div>
					<div className="partners-top">
						<ul className="partners-list">
							<li className="partner-item"><img src={client01} alt={client01}/></li>
							<li className="partner-item"><img src={client02} alt={client02}/></li>
							<li className="partner-item"><img src={client03} alt={client03}/></li>
							<li className="partner-item"><img src={client04} alt={client04}/></li>
							<li className="partner-item"><img src={client05} alt={client05}/></li>
							<li className="partner-item"><img src={client06} alt={client06}/></li>
							<li className="partner-item"><img src={client07} alt={client07}/></li>
							<li className="partner-item"><img src={client01} alt={client01}/></li>
							<li className="partner-item"><img src={client02} alt={client02}/></li>
							<li className="partner-item"><img src={client03} alt={client03}/></li>
							<li className="partner-item"><img src={client04} alt={client04}/></li>
							<li className="partner-item"><img src={client05} alt={client05}/></li>
							<li className="partner-item"><img src={client06} alt={client06}/></li>
							<li className="partner-item"><img src={client07} alt={client07}/></li>
							<li className="partner-item"><img src={client01} alt={client01}/></li>
							<li className="partner-item"><img src={client02} alt={client02}/></li>
							<li className="partner-item"><img src={client03} alt={client03}/></li>
							<li className="partner-item"><img src={client04} alt={client04}/></li>
							<li className="partner-item"><img src={client05} alt={client05}/></li>
							<li className="partner-item"><img src={client06} alt={client06}/></li>
						</ul>
					</div>
					<div className="partners-bottom">
						<ul className="partners-list">							
							<li className="partner-item"><img src={client01} alt={client01}/></li>
							<li className="partner-item"><img src={client02} alt={client02}/></li>
							<li className="partner-item"><img src={client03} alt={client03}/></li>
							<li className="partner-item"><img src={client04} alt={client04}/></li>
							<li className="partner-item"><img src={client05} alt={client05}/></li>
							<li className="partner-item"><img src={client06} alt={client06}/></li>
							<li className="partner-item"><img src={client07} alt={client07}/></li>
							<li className="partner-item"><img src={client01} alt={client01}/></li>
							<li className="partner-item"><img src={client02} alt={client02}/></li>
							<li className="partner-item"><img src={client03} alt={client03}/></li>
							<li className="partner-item"><img src={client04} alt={client04}/></li>
							<li className="partner-item"><img src={client05} alt={client05}/></li>
							<li className="partner-item"><img src={client06} alt={client06}/></li>
							<li className="partner-item"><img src={client07} alt={client07}/></li>
							<li className="partner-item"><img src={client01} alt={client01}/></li>
							<li className="partner-item"><img src={client02} alt={client02}/></li>
							<li className="partner-item"><img src={client03} alt={client03}/></li>
							<li className="partner-item"><img src={client04} alt={client04}/></li>
							<li className="partner-item"><img src={client05} alt={client05}/></li>
							<li className="partner-item"><img src={client06} alt={client06}/></li>
						</ul>
					</div>
				</section>
			</div>


			{/* <div className="veil"></div> */}
		</main>
    </div>
  );
};
